export default "__VITE_ASSET__uIpyUJE7__"